import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RmCountPriceListDto } from "./rm-count-pricelist-dto";

export interface InvalidRecords {
  invalidRecords: { count: number; type: string; maxEffectiveDate: Date }[];
}

export class RmCountPriceListResponseModel extends GlobalResponseObject {
  data: RmCountPriceListDto[] | InvalidRecords;

  constructor(
    status: boolean,
    intlCode: number,
    internalMessage: string,
    data: RmCountPriceListDto[] | InvalidRecords = []
  ) {
    super(status, intlCode, internalMessage);
    this.data = data;
  }
}